import styled from 'styled-components'

const H2 = styled.h2`
  color: ${props => props.theme.colors.darkGray};
  font-weight: 600;
`

export default H2
